import React from 'react';
import { useTranslation } from 'react-i18next';

import TrackerCard from '../TrackerCard/TrackerCard';

import styles from './TrackerColumn.module.scss';

const LoadingSkeleton = () =>
  Array.from({ length: 3 }).map((unused, i) => (
    <div key={`skel-${i}`} className={styles.cardSkeleton}>
      <div className={styles.skeletonLine} style={{ width: '70%' }} />
      <div className={styles.skeletonLine} style={{ width: '90%' }} />
      <div className={styles.skeletonLine} style={{ width: '50%' }} />
    </div>
  ));

const EmptyState = ({ message }) => <div className={styles.empty}>{message}</div>;

const TrackerColumn = ({ title, jobs, count, color, direction, isLoading, status }) => {
  const { t } = useTranslation('common');

  const renderContent = () => {
    if (isLoading) return <LoadingSkeleton />;
    if (jobs.length === 0) return <EmptyState message={t('tracker.nothingYet', 'Nothing yet')} />;
    return jobs.map((job, idx) => (
      <TrackerCard key={`${job.id || job.uuid}-${idx}`} job={job} direction={direction} status={status} />
    ));
  };

  return (
    <div className={styles.column}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.colorDot} style={{ backgroundColor: color }} />
          <span className={styles.title}>{title}</span>
        </div>
        <span className={styles.count}>{isLoading ? '-' : count}</span>
      </div>

      {/* Cards */}
      <div className={styles.cardList}>{renderContent()}</div>
    </div>
  );
};

export default TrackerColumn;
